import { render, staticRenderFns } from "./PrivacyConsent.vue?vue&type=template&id=88f0aff6&scoped=true"
import script from "./PrivacyConsent.vue?vue&type=script&lang=js"
export * from "./PrivacyConsent.vue?vue&type=script&lang=js"
import style0 from "./PrivacyConsent.vue?vue&type=style&index=0&id=88f0aff6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f0aff6",
  null
  
)

export default component.exports